/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Minutes_MoreInputs */

const en_confirm_minutes_more = /** @type {(inputs: Confirm_Minutes_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 minutes more`)
};

const he_confirm_minutes_more = /** @type {(inputs: Confirm_Minutes_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 דקות יותר`)
};

/**
* | output |
* | --- |
* | "15 minutes more" |
*
* @param {Confirm_Minutes_MoreInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_minutes_more = /** @type {((inputs?: Confirm_Minutes_MoreInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Minutes_MoreInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_minutes_more(inputs)
	return he_confirm_minutes_more(inputs)
});